import React from "react";

const TSPaySessionExpired = () => {
  return (
    <div className="dbx-tspay-payment-expired">
      Sessione scaduta. Esegui nuovamente la procedura di pagamento con TSPay
    </div>
  );
};

export default TSPaySessionExpired;
